<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>{{ id === 'new' ? 'Nueva' : 'Editar' }} categoría</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <!-- <b-form-group
                id="input-reference"
                class="col-3"
                label="Nombre"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <b-form-group
                id="input-parent"
                class="col-3"
                label="Categoría madre"
                label-for="parent"
              >
                <b-form-select
                  :options="parentOptions"
                  id="parent"
                  v-model="$v.form.parent.$model"
                  :state="validateState('parent')"
                  aria-describedby="input-parent-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-parent-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-col cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen y vista previa'"
                    description="Tamaño recomendado: 768 x 1024 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image'"
                        v-model="$v.form['image'].$model"
                        @input="changedImage('imageURI', $event)"
                        :state="validateState('image')"
                        :aria-describedby="'input-image' + '-feedback'"
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['imageURI']"
                          variant="outline-danger"
                          size="sm"
                          @click="removeImage('image', 'imageURI')"
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img style="max-height: 10rem" :src="form['imageURI']" />
                    </div> </b-form-group></b-row
              ></b-col>

              <b-col cols="3">
                <b-row>
                  <b-form-group
                    id="input-image"
                    class="col-12"
                    :label="'Imagen portada y vista previa'"
                    description="Tamaño recomendado: 731 x 828 píxeles. Dejar vacío para mantener la imagen actual"
                    label-for="image"
                  >
                    <b-input-group>
                      <b-form-file
                        accept="image/*"
                        :id="'image_cta'"
                        v-model="$v.form['image_cta'].$model"
                        @input="changedImage('image_ctaURI', $event)"
                        :state="validateState('image_cta')"
                        :aria-describedby="'input-image' + '-feedback'"
                        drop-placeholder="Arrastra un archivo aquí..."
                      ></b-form-file>
                      <b-input-group-append>
                        <b-button
                          :disabled="!form['image_ctaURI']"
                          variant="outline-danger"
                          size="sm"
                          @click="removeImage('image_cta', 'image_ctaURI')"
                          ><b-icon icon="trash"
                        /></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-image-feedback"
                      >Debes seleccionar una imagen válida (formato PNG o
                      JPEG).</b-form-invalid-feedback
                    > </b-form-group
                  ><b-form-group id="input-preview" class="col-12 text-center">
                    <div>
                      <img
                        style="max-height: 10rem"
                        :src="form['image_ctaURI']"
                      />
                    </div> </b-form-group></b-row
              ></b-col>
            </b-form-row>
            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-reference_' + lang"
                :label="'Nombre (' + languageNames[i] + ')'"
                :label-for="'reference_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'reference_' + lang"
                  v-model="$v.form['reference_' + lang].$model"
                  :state="validateState('reference_' + lang)"
                  :aria-describedby="'input-reference_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-reference_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-slug_' + lang"
                :label="'Slug (' + languageNames[i] + ')'"
                :label-for="'slug_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'slug_' + lang"
                  v-model="$v.form['slug_' + lang].$model"
                  :state="validateState('slug_' + lang)"
                  :aria-describedby="'input-slug_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-slug_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-row>
              <b-col cols="12">
                <h2>CTA</h2>
              </b-col>
            </b-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :label="'Párrafo Header CTA (' + languageNames[i] + ')'"
                :label-for="'cta_paragraph_' + lang"
                class="col-6"
              >
                <vue-editor
                  v-model="$v.form['cta_paragraph_' + lang].$model"
                ></vue-editor>
                <b-form-invalid-feedback
                  :id="'input-cta_paragraph_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-cta_btn_text_1_' + lang"
                :label="'Texto botón izquierdo (' + languageNames[i] + ')'"
                :label-for="'cta_btn_text_1_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'cta_btn_text_1_' + lang"
                  v-model="$v.form['cta_btn_text_1_' + lang].$model"
                  :state="validateState('cta_btn_text_1_' + lang)"
                  :aria-describedby="
                    'input-cta_btn_text_1_' + lang + '- feedback'
                  "
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-cta_btn_text_1_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-cta_btn_text_2_' + lang"
                :label="'Texto botón derecho (' + languageNames[i] + ')'"
                :label-for="'cta_btn_text_2_' + lang"
                class="col-3"
              >
                <b-form-input
                  :id="'cta_btn_text_2_' + lang"
                  v-model="$v.form['cta_btn_text_2_' + lang].$model"
                  :state="validateState('cta_btn_text_2_' + lang)"
                  :aria-describedby="
                    'input-cta_btn_text_2_' + lang + '- feedback'
                  "
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-cta_btn_text_2_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-cta_btn_loc_2"
                class="col-3"
                label="Enlace con categoría de colección (botón derecho)"
                label-for="cta_btn_loc_2"
              >
                <b-form-select
                  :options="cta_btn_loc_2Options"
                  id="cta_btn_loc_2"
                  v-model="$v.form.cta_btn_loc_2.$model"
                  :state="validateState('cta_btn_loc_2')"
                  aria-describedby="input-cta_btn_loc_2-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-cta_btn_loc_2-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-row>
              <b-col cols="12">
                <h2>SEO</h2>
              </b-col>
            </b-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-title_tag_' + lang"
                :label="'Meta title (' + languageNames[i] + ')'"
                :description="
                  lang === 'es'
                    ? 'Título que aparecerá en la ventana del navegador para las categorías de primer nivel (ej. Individuales, Servilletas, Manteles...). Si se deja en blanco, se utilizará el genérico: \'from:BEA\''
                    : ''
                "
                :label-for="'title_tag_' + lang"
                class="col-6"
              >
                <b-form-input
                  :id="'title_tag_' + lang"
                  v-model="$v.form['title_tag_' + lang].$model"
                  :state="validateState('title_tag_' + lang)"
                  :aria-describedby="'input-title_tag_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-title_tag_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :description="
                  lang === 'es'
                    ? 'Descripción de las páginas que se usarán en las categorías de primer nivel (ej. Individuales, Servilletas, Manteles...). Si se deja en blanco, se utilizará el genérico: \'Tu ropa de casa siempre a tu gusto: personalizada y 100% a medida en 3 simples pasos.\''
                    : ''
                "
                :id="'input-meta_description_' + lang"
                :label="'Meta description (' + languageNames[i] + ')'"
                :label-for="'meta_description_' + lang"
                class="col-6"
              >
                <b-form-input
                  :id="'meta_description_' + lang"
                  v-model="$v.form['meta_description_' + lang].$model"
                  :state="validateState('meta_description_' + lang)"
                  :aria-describedby="
                    'input-meta_description_' + lang + '- feedback'
                  "
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-meta_description_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :id="'input-free_title_' + lang"
                :label="'Título libre SEO (' + languageNames[i] + ')'"
                :label-for="'free_title_' + lang"
                class="col-6"
              >
                <b-form-input
                  :id="'free_title_' + lang"
                  v-model="$v.form['free_title_' + lang].$model"
                  :state="validateState('free_title_' + lang)"
                  :aria-describedby="'input-free_title_' + lang + '- feedback'"
                ></b-form-input>
                <b-form-invalid-feedback
                  :id="'input-free_title_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                :key="lang"
                v-for="(lang, i) in languageCodes"
                :label="'Párrafo libre SEO (' + languageNames[i] + ')'"
                :label-for="'free_paragraph_' + lang"
                class="col-6"
              >
                <vue-editor
                  v-model="$v.form['free_paragraph_' + lang].$model"
                ></vue-editor>
                <b-form-invalid-feedback
                  :id="'input-free_paragraph_' + lang + '-feedback'"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-button type="submit" variant="primary"
              >Guardar categoría</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import { VueEditor } from 'vue2-editor';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminProductCategoriesEditScreen',
  props: ['id'],
  components: { VueEditor },
  mixins: [validationMixin],
  validations() {
    let rules = {
      parent: {},
      cta_btn_loc_2: {},
      image: { isValidImage },
      image_cta: { isValidImage },
    };

    this.languageCodes.map((x) => {
      // Only 'es' lang required
      // rules['reference_' + x] = x === 'es' ? { required } : {};

      // Enforcing SEO, all langs required
      rules['reference_' + x] = { required };
      rules['slug_' + x] = { required };

      rules['free_title_' + x] = {};
      rules['title_tag_' + x] = {};
      rules['meta_description_' + x] = {};

      rules['cta_btn_text_1_' + x] = { required };
      rules['cta_btn_text_2_' + x] = {};
      rules['free_paragraph_' + x] = {};
      rules['cta_paragraph_' + x] = {};
    });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      name: '',
      description: '',
      reference: '',
      parent: null,
      cta_btn_loc_2: null,
      image: null,
      imageURI: null,
      image_cta: null,
      image_ctaURI: null,

      error: {
        show: false,
        text: '',
      },
    };
    store.getLanguageCodes().map((x) => {
      form['reference_' + x] = '';
      form['slug_' + x] = '';

      form['free_title_' + x] = '';
      form['title_tag_' + x] = '';
      form['meta_description_' + x] = '';

      form['cta_btn_text_1_' + x] = '';
      form['cta_btn_text_2_' + x] = '';
      form['free_paragraph_' + x] = '';
      form['cta_paragraph_' + x] = '';
    });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      parentOptions: [],
      cta_btn_loc_2Options: [],
      form: form,
    };
  },
  created() {
    actions.getProductCategoriesUnpaginated().then((x) => {
      //  Parent
      this.parentOptions = x.data.results.map((y) => {
        return {
          value: y.id,
          text: y.reference,
        };
      });

      this.parentOptions.push({ value: null, text: '-' });

      // cta_btn_loc_2

      actions.getPredefinedProductCategoriesUnpaginated().then((x) => {
        //  Parent
        this.cta_btn_loc_2Options = x.data.results
          .filter((yy) => yy.parent !== null)
          .map((y) => {
            return {
              value: y.id,
              text: (y.parent_name ? y.parent_name + ', ' : '') + y.reference,
            };
          });

        this.cta_btn_loc_2Options.push({ value: null, text: '-' });

        if (this.id !== 'new') {
          actions.getProductCategory(this.id).then((z) => {
            const data = z.data;

            this.form.reference = data.reference;
            // this.form.name = data.name;
            // this.form.description = data.description;
            this.form.parent = data.parent;
            this.form.cta_btn_loc_2 = data.cta_btn_loc_2;
            this.form.imageURI = data.image;
            this.form.image_ctaURI = data.image_cta;

            this.languageCodes.map((y) => {
              this.form['reference_' + y] = data['reference_' + y];
              this.form['slug_' + y] = data['slug_' + y];

              this.form['free_title_' + y] = data['free_title_' + y];
              this.form['title_tag_' + y] = data['title_tag_' + y];
              this.form['meta_description_' + y] =
                data['meta_description_' + y];
              this.form['cta_btn_text_1_' + y] = data['cta_btn_text_1_' + y];
              this.form['cta_btn_text_2_' + y] = data['cta_btn_text_2_' + y];
              this.form['free_paragraph_' + y] = data['free_paragraph_' + y];
              this.form['cta_paragraph_' + y] = data['cta_paragraph_' + y];
            });
          });
        }
      });
    });
  },
  methods: {
    removeImage(i, i2) {
      this.form[i] = null;
      this.form[i2] = null;
    },
    getDataURIFromFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    changedImage(i, newFile) {
      this.getDataURIFromFile(newFile).then((result) => {
        this.form[i] = result;
      });
    },
    // changedImage(newFile) {
    //   this.getDataURIFromFile(newFile).then((result) => {
    //     this.form.imageURI = result;
    //   });
    // },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {};
      let dataimg = new FormData();

      if (this.form.image !== null) {
        dataimg.append('image', this.form.image);
      } else if (this.form.imageURI === null) {
        dataimg.append('image', new File([], ''));
      }

      if (this.form.image_cta !== null) {
        dataimg.append('image_cta', this.form.image_cta);
      } else if (this.form.image_ctaURI === null) {
        dataimg.append('image_cta', new File([], ''));
      }

      // data.append('reference', this.form.reference);
      data['parent'] = this.form.parent;
      data['cta_btn_loc_2'] = this.form.cta_btn_loc_2;
      data['reference'] = this.form.reference_es;
      data['slug'] = this.form.slug_es;

      data['free_title'] = this.form.free_title_es;
      data['title_tag'] = this.form.title_tag_es;
      data['meta_description'] = this.form.meta_description_es;
      data['cta_btn_text_1'] = this.form.cta_btn_text_1_es;
      data['cta_btn_text_2'] = this.form.cta_btn_text_2_es;
      data['free_paragraph'] = this.form.free_paragraph_es;
      data['cta_paragraph'] = this.form.cta_paragraph_es;

      this.languageCodes.map((x) => {
        data['reference_' + x] = this.form['reference_' + x];
        data['slug_' + x] = this.form['slug_' + x];

        data['free_title_' + x] = this.form['free_title_' + x];
        data['title_tag_' + x] = this.form['title_tag_' + x];
        data['meta_description_' + x] = this.form['meta_description_' + x];
        data['cta_btn_text_1_' + x] = this.form['cta_btn_text_1_' + x];
        data['cta_btn_text_2_' + x] = this.form['cta_btn_text_2_' + x];
        data['free_paragraph_' + x] = this.form['free_paragraph_' + x];
        data['cta_paragraph_' + x] = this.form['cta_paragraph_' + x];

        // data['description_' + x] = this.form['description_' + x];
      });

      // data['name'] = this.form['name_' + this.languageCodes[0]];
      // data['description'] = this.form['description_' + this.languageCodes[0]];

      if (this.id === 'new') {
        actions.postProductCategory(data).then((x) => {
          this.$router.push({ name: 'AdminProductCategoriesScreen' });
        });
      } else {
        Promise.all([
          actions.patchProductCategory(this.id, data),
          actions.patchProductCategory(this.id, dataimg),
        ]).then((x) => {
          this.$router.push({
            name: 'AdminProductCategoriesScreen',
          });
        });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
